import { IconProps } from "@/common/contracts/icon.contracts";

export const IdeaBulb = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 11H23V13H20V11ZM1 11H4V13H1V11ZM13 1V4H11V1H13ZM4.92 3.5L7.05 5.64L5.63 7.05L3.5 4.93L4.92 3.5ZM16.95 5.63L19.07 3.5L20.5 4.93L18.37 7.05L16.95 5.63ZM12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 14.22 16.79 16.16 15 17.2V19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20H10C9.73478 20 9.48043 19.8946 9.29289 19.7071C9.10536 19.5196 9 19.2652 9 19V17.2C7.21 16.16 6 14.22 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6ZM14 21V22C14 22.2652 13.8946 22.5196 13.7071 22.7071C13.5196 22.8946 13.2652 23 13 23H11C10.7348 23 10.4804 22.8946 10.2929 22.7071C10.1054 22.5196 10 22.2652 10 22V21H14ZM11 18H13V15.87C14.73 15.43 16 13.86 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.86 9.27 15.43 11 15.87V18Z"
        fill="currentColor"
      />
    </svg>
  );
};
